import { sparkToast } from '@spark';

/** Toast title when a move is refused because every selected task is deployed. */
export const MOVE_BLOCKED_TITLE = 'Deployed tasks can’t be moved';

const TOAST_DURATION_MS = 6000;

const quoteList = (names = []) => {
    const quoted = names.map((name) => `"${name}"`);
    if (quoted.length <= 1) return quoted[0] || 'it';
    return `${quoted.slice(0, -1).join(', ')} and ${quoted[quoted.length - 1]}`;
};

/**
 * Explains how to unblock a move: undeploy first, then move.
 * `Undeploy "A" first, then move it to another project.`
 * `Undeploy "A" and "B" first, then move them to another project.`
 */
export const undeployToMoveText = (names = []) => {
    const list = Array.isArray(names) ? names.filter(Boolean) : [];
    if (list.length === 0) {
        return 'Undeploy the deployed task first, then move it to another project.';
    }
    const pronoun = list.length === 1 ? 'it' : 'them';
    return `Undeploy ${quoteList(list)} first, then move ${pronoun} to another project.`;
};

export const moveBlockedToast = (names = []) => {
    sparkToast.error(MOVE_BLOCKED_TITLE, {
        content: undeployToMoveText(names),
        detailed: true,
        duration: TOAST_DURATION_MS,
    });
};

const plural = (count, noun) => `${count} ${noun}${count === 1 ? '' : 's'}`;

/**
 * Toast copy for a (guarded) bulk move. Pure so tests can assert on it.
 */
export const bulkMoveToast = ({
    moved = 0,
    failures = [],
    blockedTaskNames = [],
    destGroupName = '',
} = {}) => {
    const blocked = blockedTaskNames.length;
    if (moved === 0 && failures.length === 0 && blocked > 0) {
        return { type: 'error', title: MOVE_BLOCKED_TITLE, content: undeployToMoveText(blockedTaskNames) };
    }
    if (failures.length > 0) {
        return { type: 'error', title: failures[0] || 'Failed to move tasks' };
    }
    if (blocked > 0) {
        return {
            type: 'warning',
            title: `Moved ${plural(moved, 'task')} to ${destGroupName}. Skipped ${plural(blocked, 'deployed task')}.`,
            content: undeployToMoveText(blockedTaskNames),
        };
    }
    return { type: 'success', title: `Moved ${plural(moved, 'item')} to ${destGroupName}` };
};

export const showBulkMoveResultToast = (args) => {
    const { type, title, content } = bulkMoveToast(args);
    if (content) {
        sparkToast[type](title, { content, detailed: true, duration: TOAST_DURATION_MS });
        return;
    }
    sparkToast[type](title);
};
